import React from 'react';
import BlazeLink from '../BlazeLink';
import SearchContentItems from './SearchContentItems';
const SearchContentResults = ({
  results,
  debouncedSearchTerm,
  onClick
}) => {
  if (!debouncedSearchTerm) return null;
  const hasResults = results.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "search-content--results__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-content--results__wrapper--message"
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-content--results__content"
  }, hasResults ? /*#__PURE__*/React.createElement(SearchContentItems, {
    results: results,
    onClick: onClick
  }) : /*#__PURE__*/React.createElement("div", {
    className: "search-content--results__message"
  }, /*#__PURE__*/React.createElement(BlazeLink, {
    href: `/search?search_term=${debouncedSearchTerm}`
  }, `Search all results for: ${debouncedSearchTerm}`)))));
};
export default SearchContentResults;
//# sourceMappingURL=SearchContentResults.js.map